// extracted by mini-css-extract-plugin
module.exports = {"sub":"FontScale_sub__Nan_7"};